import { useMemo } from "react";
import { Alert } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";
import LoadingMask from "../../../components/LoadingMask/LoadingMask";
import { useAppAuthState } from "../../../hooks/use-app-auth-state";
import { useDocumentTitle } from "../../../hooks/use-document-title";
import { useRedirectIfNotAdmin } from "../../../hooks/use-redirect-if-not-admin";
import {
  SearchParams,
  useSearchableInvestorSearchResults,
} from "../../../hooks/use-searchable-investor-search-results";

const AdminDebugFieldPage: React.FC = () => {
  useDocumentTitle("Debug Field | Admin");
  useRedirectIfNotAdmin();

  const [searchParams] = useSearchParams();
  const targetField: string | null = searchParams.get("targetField");
  const selectedValues = searchParams.get("selectedValues");
  const finalValue = searchParams.get("finalValue");

  const { fireUser, isAuthLoading, isUserAdmin } = useAppAuthState();

  const searchParamsObject: SearchParams | null = useMemo(() => {
    return isUserAdmin &&
      targetField &&
      selectedValues &&
      selectedValues.length > 0
      ? {
          [targetField]: selectedValues[0],
        }
      : null;
  }, [targetField, selectedValues, isUserAdmin]);

  const {
    results: searchableInvestorSearchResults,
    loading: searchableInvestorSearchResultsLoading,
    error: searchableInvestorSearchResultsError,
  } = useSearchableInvestorSearchResults(searchParamsObject);

  if (searchableInvestorSearchResultsError) {
    return (
      <div className="admin-home-page">
        <div className="page-header">Debug Field</div>
        <Alert variant="danger">{searchableInvestorSearchResultsError}</Alert>
      </div>
    );
  }

  if (isAuthLoading || !isUserAdmin || !fireUser) {
    return <LoadingMask message="Loading admin page..." />;
  }

  if (searchableInvestorSearchResultsLoading) {
    return (
      <LoadingMask message="Loading searchable investor search results..." />
    );
  }

  return (
    <div className="admin-home-page">
      <div className="page-header">
        Debug Field
        <div className="page-subheader">
          {targetField}:{selectedValues} &rarr; {finalValue}
        </div>
      </div>
      <div className="results-section">
        {searchableInvestorSearchResults.map((result) => (
          <div key={result.id}>{result.name}</div>
        ))}
        {searchableInvestorSearchResults.length === 0 && (
          <Alert variant="info">No results found</Alert>
        )}
      </div>
    </div>
  );
};

export default AdminDebugFieldPage;
